module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Italic.7d393d3.woff2";